<template>
  <div style="height:100vh;">
    <div class="row h-100 mx-0">
      <div class="col-0 col-lg-6 d-none d-lg-flex px-0">
        <div class="h-100 w-100 sb-image-background" loading="lazy">
          <div
            class="h-100 d-flex align-items-center justify-content-center text-center"
            style="background-color: rgba(84, 19, 136, 0.4);text-shadow: 1px 1px 5px black"
          >
            <div>
              <h1 class="text-white font-weight-normal mb-4 hero-title">
                <strong>TN CyberTech Bank</strong>
              </h1>
<!--
              <h2 class="text-white">Everyday Banking For Everyday People</h2>
-->
            </div>
          </div>
        </div>
      </div>
      <div class=" col-12 col-lg-6 pr-0 pr-lg-1 d-flex align-items-center px-0">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BasePage",
  mounted() {
    this.checkToken();
  },
  methods: {
    checkToken: function() {
      const token = localStorage.getItem("access_token");
      if (
        (token === null || typeof token === "undefined") &&
        this.$route.name !== "Login" &&
        this.$route.name !== "DefaultLogin"
      ) {
        this.$router.push("/account-opening/login");
      }
    }
  }
};
</script>
